/* 🤖 this file was generated by svg-to-ts */
export const matIconVerticalAlignTop: {
  name: 'vertical-align-top';
  data: string;
} = {
  name: 'vertical-align-top',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z"/></svg>`
};
